const CHUNK_RELOAD_SESSION_KEY = "cu-chunk-reload-once";

/** Erkennt typische Fehler nach Deploy (alter Tab, fehlende JS-Chunks). */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";

  if (!message) return false;

  const normalized = message.toLowerCase();
  return (
    normalized.includes("failed to fetch dynamically imported module") ||
    normalized.includes("error loading dynamically imported module") ||
    normalized.includes("importing a module script failed") ||
    normalized.includes("loading chunk") ||
    normalized.includes("loading css chunk") ||
    normalized.includes("dynamically imported module")
  );
}

export function clearChunkReloadFlag(): void {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Einmal pro Tab-Session neu laden (verhindert Reload-Schleifen).
 * @returns true wenn Reload ausgelöst wurde
 */
export function tryReloadOnceForChunkError(): boolean {
  if (typeof window === "undefined") return false;

  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
      return false;
    }
    sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, String(Date.now()));
  } catch {
    return false;
  }

  window.location.reload();
  return true;
}

/** Global: Vite-Preload + unhandledrejection → einmal reload. */
export function registerChunkLoadRecovery(): void {
  if (typeof window === "undefined") return;

  window.addEventListener("vite:preloadError", event => {
    event.preventDefault();
    tryReloadOnceForChunkError();
  });

  window.addEventListener("unhandledrejection", event => {
    if (!isChunkLoadError(event.reason)) return;
    event.preventDefault();
    tryReloadOnceForChunkError();
  });

  window.addEventListener("load", () => {
    clearChunkReloadFlag();
  });
}
